// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3F7MH","buttons":"Footer_buttons__2HB40"};